<template>
  <div class="fab-doc">
    <div class="right-bottom">
      <fab />
    </div>
  </div>
</template>

<script>
import FAB from '@/components/FAB'

export default {
  name: 'adx-fab-doc',
  components: {
    'fab': FAB
  }
}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>